/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import {Alert , Button , ButtonToolbar , Row , Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6
import $ from 'jquery';

const FADE_DURATION = 200;



const Step = React.createClass({

    getInitialState(){
       // this._handleDocumentClick = this.handleKeyPress.bind(this);
        return {
            advanceDisabled: false,
            retreatDisabled: false,
            data:this.props.data,
        };
    },

    handleKeyPress(target) {
        if(target.charCode==13){
            this.onSubmit();
        }
    },

    componentWillMount(){
       // $(document).on('keypress', this._handleDocumentClick);
    },


    componentWillUnmount() {
       // $(document).off('keypress' , this._handleDocumentClick);
    },

    onAdvance(err){
        if(err){
            this.setState({advanceDisabled: false, retreatDisabled: false, currentError: err});
        }else{
            this.props.onAdvance();
        }
    },

    onSubmit: function(){
        this.setState({
            advanceDisabled: true,
            retreatDisabled: true
        });
        this.props.onSubmit.apply(this, [this.onAdvance]);
    },

    onBack: function(){
        if(this.props.onBack){
            this.props.onBack.apply(this, [this.props.onRetreat]);
        }else{
            this.props.onRetreat();
        }
    },


    render: function(){

        var AdvanceButton;
        var DefaultAdvanceButton;
        if(!this.props.lastStep){
            AdvanceButton = React.createElement(Button, {
                onClick: this.onSubmit,
                disabled: this.state.advanceDisabled,
                bsStyle:'primary',
                className:"btn-block",
            },<FormattedMessage id="ui-236" defaultMessage="Next"/>);
        }


        var RetreatButton;
        if(!this.props.lastStep){
            RetreatButton = React.createElement(Button, {
                onClick: this.onBack,
                disabled: this.props.firstStep || this.state.retreatDisabled,
                bsStyle:'primary',
                className:"btn-block",
                smHidden:true
            },<FormattedMessage id="ui-116" defaultMessage="Back"/>);
        }

        var ComponentClass = this.props.component;


        console.log(ComponentClass.disableButtons);
        var Error;
        if(this.state.currentError && !this.props.handelError){
            Error = <Alert key="wizard-alert" className="palette-Branding red bg" bsStyle="danger"><p>{this.state.currentError.message}</p></Alert>;
        }


        let buttons = <Row>
            <Col className="pull-right" sm={3}>{AdvanceButton}</Col>
            <Col className="pull-right" sm={3}>{RetreatButton}</Col>
        </Row>

        if(this.props.disableButtons) buttons = null;

        return <div className="step">

            <ComponentClass onModify={this.props.onModify} onSubmit={AdvanceButton} Error={Error} data={this.props.data}  forceAdvance={this.onSubmit}/>

            <ReactCSSTransitionGroup transitionName="example" transitionAppearTimeout={500} transitionAppear={true} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                {Error}
            </ReactCSSTransitionGroup>

            {buttons}
        </div>;
    }

});

export default Step


// WEBPACK FOOTER //
// ./src/components/wizard/wizard-step.js